import { render, staticRenderFns } from "./HkDialog.vue?vue&type=template&id=230cf3e6&scoped=true&"
import script from "./HkDialog.vue?vue&type=script&lang=js&"
export * from "./HkDialog.vue?vue&type=script&lang=js&"
import style0 from "./HkDialog.vue?vue&type=style&index=0&id=230cf3e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230cf3e6",
  null
  
)

export default component.exports